module.exports = __webpack_public_path__ + "img/sys.a9946479.png";